// extracted by mini-css-extract-plugin
export default {"QuestionsHeader":"styles_QuestionsHeader__dQmkL","questionCount":"styles_questionCount__F+85F","counter":"styles_counter__ZrhHY","title":"styles_title__mEvwl"};